import React from 'react';
import PropTypes from 'prop-types';
import ConfirmButton from '../ConfirmButton';
import styles from '../../styles/test/TestStyles.module.css';

/**
 * ReviewHeader component for displaying the review header with clear button
 */
const ReviewHeader = ({ title, type, onClearFailures }) => {
  return (
    <div className={styles.headerActions}>
      <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 'bold', textTransform: 'uppercase' }}>
        {title} {type === 'viajeros' ? 'Viajeros' : 'Mercancías'}
      </h2>
      <ConfirmButton
        variant="error"
        initialText="Limpiar fallos"
        confirmText="¿Seguro? Click para confirmar"
        onConfirm={onClearFailures}
        aria-label="Eliminar todas las preguntas falladas"
      />
    </div>
  );
};

ReviewHeader.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onClearFailures: PropTypes.func.isRequired
};

export default ReviewHeader;